/**
 * Admin feature helpers - store-coupled utilities for admin tab components.
 */

import { store } from "../../../platform/store/DataStore.js";

/**
 * Initialize edit state properties for a component.
 * Call this in the component's constructor.
 * @param {LitElement} component - The component to initialize
 * @param {string} editingProperty - Name of the editing ID property
 */
export function initializeEditState(component, editingProperty = "editingId") {
  component[editingProperty] = null;
  component.message = "";
  component.messageType = "";
}

/**
 * Subscribe component to store updates.
 * Call this in the component's constructor after initializeEditState.
 * @param {LitElement} component - The component to subscribe
 */
export function subscribeToStore(component) {
  store.subscribe(() => {
    if (component.cohorts !== undefined) {
      const newCohorts = store.getCohorts();
      component.cohorts = newCohorts;
    }
    component.requestUpdate();
  });
}
